<template>
    <b-modal title="রোল তৈরি" no-close-on-backdrop hide-footer size="xl"  v-model="largeModal" @ok="largeModal = false">

        <form @submit.prevent="addRole" >
            <div>
                <div class="form-group row">
                    <label for="inputPassword3" class="col-sm-2 col-form-label">রোল নাম</label>
                    <div class="col-sm-10">
                    <input name="Name" v-validate="'required'" v-model="rolePermission.name" type="text" class="form-control"  placeholder="রোল নাম">
                    <div v-show="errors.has('Name')" class="help-block alert alert-danger">
                        {{ errors.first('Name') }}
                    </div>
                    </div>
                </div>
            </div>
            <table class="table table-sm">
                <thead>
                    <tr>
                        <th scope="col">Module</th>
                        <th scope="col">View</th>
                        <th scope="col">Create</th>
                        <th scope="col">Update</th>
                        <th scope="col">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>হোল্ডিং</td>
                        <td ><c-switch  class="mx-1" color="info" label outline="alt" variant="pill" v-model="rolePermission.holding_view"/></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.holding_create"  /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.holding_update" /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.holding_delete"  /></td>
                    </tr>
                    <tr>
                        <td>সেটিংস</td>
                        <td ><c-switch  class="mx-1" color="info" label outline="alt" variant="pill" v-model="rolePermission.settings_view"  /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.settings_create"  /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.settings_update" /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.settings_delete"  /></td>
                    </tr>
                    <tr >
                        <td>ইউজার রোল</td>
                        <td ><c-switch  class="mx-1" color="info" label outline="alt" variant="pill" v-model="rolePermission.role_view"  /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.role_create"  /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.role_update" /></td>
                        <td><c-switch class="mx-1" color="info"  label outline="alt" variant="pill"  v-model="rolePermission.role_delete" /></td>
                    </tr>
                </tbody>
            </table>
            <div class="form-group row">
                <div class="col-sm-12">
                <input v-if="!addLoader" type="submit" value="Submit" class="btn btn-primary pull-right"/>
                <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
                <button v-if="!addLoader"  @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
import axios from 'axios'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate)

import { ADD_USER_ROLE} from "../../store/action.type"
// import { ADD_CONTACT_LOADER} from "../../store/mutation.type"
import { mapState,mapGetters } from "vuex"

export default {
    data(){
        return{
            tab:1,
            largeModal:false,
            addLoader:false,
            rolePermission:{
                role_name:'',

                settings_view:false,
                settings_create:false,
                settings_update:false,
                settings_delete:false,

                holding_view:false,
                holding_create:false,
                holding_update:false,
                holding_delete:false,

                role_view:false,
                role_create:false,
                role_update:false,
                role_delete:false,

            }
        }
    },
    methods:{
        addRole () {
            this.$validator.validateAll().then( result =>{
                if(result){
                    var data = this.rolePermission
                    this.addLoader = true
                    this.$store.dispatch('ADD_USER_ROLE',data)
                    .then(response=>{
                        this.addLoader = false;
                        this.largeModal = false
                        this.$iziToast.success({position:'topRight',title:'Ok',message:"Role Added Successsfully"})

                    })
                    .catch(error=>{
                        this.addLoader = false;
                        this.$iziToast.error({position:'topRight',title:'Error',message:"Something Wrong !!"})
                    });
                }

            })

        },
        openModal(){
            this.largeModal = true
        },
        close(){
            this.largeModal = false
        }

    },
    components:{
        cSwitch
    }
}
</script>

<style scoped>
.nav-tabs{
    width: 100%;
    margin: 5px 15px
}
.nav-link{
    cursor: pointer;
}
.nav-tabs li i{
    padding: 5px;
}
.nav-tabs li a{
    color: #666666;
}
</style>
